/**
 * Register the dedicated Web-Push service worker (clarity-smart-notifications Req
 * 5.4). The app's main SW is `selfDestroying` (a past precache incident), so push
 * rides its OWN tiny service worker at `public/push-sw.js`, registered on demand
 * only when the owner opts into browser notifications. Scope `/app/` matches the
 * Vite base so `notificationclick` can open the in-app `actionPath`.
 */
export async function ensurePushServiceWorker(): Promise<ServiceWorkerRegistration> {
  const existing = await navigator.serviceWorker.getRegistration('/app/');
  if (existing && existing.active?.scriptURL.endsWith('push-sw.js')) return existing;
  return navigator.serviceWorker.register('/app/push-sw.js', { scope: '/app/' });
}
